import React from "react"

import {Form} from "./Form"
import {getLayout} from "./Layouts"

function New() {
	const defaultLayoutId = "6ef56d05-15b7-4610-9c1e-6be6801c59cb"
	const layout = getLayout(defaultLayoutId)

	const initialState = {
		PreviewOptions: [],
		FromName: "",
		Subject: "",
		LayoutID: defaultLayoutId,
		LayoutAttributes: layout.defaultAttributes,
		Locale: "",
		ForValidationPeriod: "",
		ForPreChargeOff: "",
		Archived: false,
		ID: "",
		Tags: [],
	}

	return <Form title="New Email Template" initialState={initialState} disabled={false} />
}

export {New}
